export const initialTokenData = [
  {
    id: "propy",
    symbol: "pro",
    name: "Propy",
    image:
      "https://coin-images.coingecko.com/coins/images/869/large/propy-pro-logo.png?1737476645",
    current_price: 0.327319,
    market_cap: 18951365,
    market_cap_rank: 1143,
    fully_diluted_valuation: 32733128,
    total_volume: 2187844,
    high_24h: 0.336536,
    low_24h: 0.326665,
    price_change_24h: -0.00167264541855133,
    price_change_percentage_24h: -0.50842,
    market_cap_change_24h: -94397.2078684606,
    market_cap_change_percentage_24h: -0.49563,
    circulating_supply: 57896591.3910539,
    total_supply: 100000000,
    max_supply: 100000000,
    ath: 5.15,
    ath_change_percentage: -93.64797,
    ath_date: "2018-01-05T00:00:00.000Z",
    atl: 0.0303544,
    atl_change_percentage: 978.31801,
    atl_date: "2020-03-13T02:24:40.087Z",
    roi: {
      times: -0.672681049243101,
      currency: "usd",
      percentage: -67.2681049243101,
    },
    last_updated: "2025-12-28T22:05:53.912Z",
    price_change_percentage_1h_in_currency: -0.455058013027281,
    price_change_percentage_24h_in_currency: -0.508415849521979,
    price_change_percentage_7d_in_currency: -0.248149319560187,
  },
  {
    id: "elysia",
    symbol: "el",
    name: "ELYSIA",
    image:
      "https://coin-images.coingecko.com/coins/images/10887/large/elysia_logo_200.png?1718149410",
    current_price: 0.00228271,
    market_cap: 15525702,
    market_cap_rank: 1255,
    fully_diluted_valuation: 15525702,
    total_volume: 474804,
    high_24h: 0.00243048,
    low_24h: 0.00221022,
    price_change_24h: 0.0000375,
    price_change_percentage_24h: 1.67019,
    market_cap_change_24h: 250908,
    market_cap_change_percentage_24h: 1.64263,
    circulating_supply: 6803300704.688,
    total_supply: 6803300704.688,
    max_supply: 7000000000,
    ath: 0.069104,
    ath_change_percentage: -96.69779,
    ath_date: "2021-04-01T22:46:46.567Z",
    atl: 0.00001996,
    atl_change_percentage: 11333.6058,
    atl_date: "2021-01-13T03:34:19.854Z",
    roi: null,
    last_updated: "2025-12-28T22:06:01.897Z",
    price_change_percentage_1h_in_currency: 1.28270719042645,
    price_change_percentage_24h_in_currency: 1.67018663433407,
    price_change_percentage_7d_in_currency: 8.80893575911536,
  },
  {
    id: "imo",
    symbol: "imo",
    name: "IMO",
    image:
      "https://coin-images.coingecko.com/coins/images/14831/large/IMO_logo_rond_200.png?1729798616",
    current_price: 0.982438,
    market_cap: 10974681,
    market_cap_rank: 1506,
    fully_diluted_valuation: 17313970,
    total_volume: 75879,
    high_24h: 0.992592,
    low_24h: 0.97261,
    price_change_24h: -0.00477247338752163,
    price_change_percentage_24h: -0.48343,
    market_cap_change_24h: -54851.2548783384,
    market_cap_change_percentage_24h: -0.49731,
    circulating_supply: 11172423,
    total_supply: 17625934.0108313,
    max_supply: 20000000,
    ath: 4.15,
    ath_change_percentage: -76.40946,
    ath_date: "2024-12-05T18:22:58.338Z",
    atl: 0.00998532,
    atl_change_percentage: 9712.1056,
    atl_date: "2024-02-04T09:16:54.267Z",
    roi: null,
    last_updated: "2025-12-28T22:06:03.105Z",
    price_change_percentage_1h_in_currency: 0.529084015407719,
    price_change_percentage_24h_in_currency: -0.483430227274379,
    price_change_percentage_7d_in_currency: 7.36508799638998,
  },
  {
    id: "reental",
    symbol: "rnt",
    name: "Reental",
    image:
      "https://coin-images.coingecko.com/coins/images/32508/large/IMG_5790.jpeg?1749836696",
    current_price: 0.186628,
    market_cap: 9893605,
    market_cap_rank: 1574,
    fully_diluted_valuation: 37305822,
    total_volume: 3231.73,
    high_24h: 0.187529,
    low_24h: 0.183292,
    price_change_24h: -0.000402838469292399,
    price_change_percentage_24h: -0.21539,
    market_cap_change_24h: -21701.2230891231,
    market_cap_change_percentage_24h: -0.21887,
    circulating_supply: 53014018.9528424,
    total_supply: 199899989,
    max_supply: 200000000,
    ath: 0.296501,
    ath_change_percentage: -37.05669,
    ath_date: "2024-05-31T09:52:30.085Z",
    atl: 0.01591959,
    atl_change_percentage: 1072.3138,
    atl_date: "2025-06-13T05:04:28.430Z",
    roi: null,
    last_updated: "2025-12-28T22:05:54.069Z",
    price_change_percentage_1h_in_currency: 0.0220262595517702,
    price_change_percentage_24h_in_currency: -0.215386662483665,
    price_change_percentage_7d_in_currency: 1.7218338325977,
  },
  {
    id: "parcl",
    symbol: "prcl",
    name: "Parcl",
    image:
      "https://coin-images.coingecko.com/coins/images/37078/large/ParclToken.png?1737478326",
    current_price: 0.02009101,
    market_cap: 9099158,
    market_cap_rank: 1631,
    fully_diluted_valuation: 20100018,
    total_volume: 816908,
    high_24h: 0.02116444,
    low_24h: 0.02001258,
    price_change_24h: -0.00100297626153631,
    price_change_percentage_24h: -4.7548,
    market_cap_change_24h: -449679.82945974,
    market_cap_change_percentage_24h: -4.70926,
    circulating_supply: 452692822.772183,
    total_supply: 999997395.153023,
    max_supply: 1000000000,
    ath: 0.736957,
    ath_change_percentage: -97.27269,
    ath_date: "2024-04-22T10:16:47.961Z",
    atl: 0.0176063,
    atl_change_percentage: 14.15867,
    atl_date: "2025-12-22T07:59:07.381Z",
    roi: null,
    last_updated: "2025-12-28T22:05:54.093Z",
    price_change_percentage_1h_in_currency: -0.305038229264186,
    price_change_percentage_24h_in_currency: -4.75479719398901,
    price_change_percentage_7d_in_currency: 11.2643577468617,
  },
  {
    id: "realtoken-ecosystem-governance",
    symbol: "reg",
    name: "RealToken Ecosystem Governance",
    image:
      "https://coin-images.coingecko.com/coins/images/37785/large/REG_Logo_200x200.png?1737625372",
    current_price: 0.118068,
    market_cap: 8644577,
    market_cap_rank: 1672,
    fully_diluted_valuation: 59224892,
    total_volume: 41.68,
    high_24h: 0.118082,
    low_24h: 0.11619,
    price_change_24h: 0.00170037,
    price_change_percentage_24h: 1.46121,
    market_cap_change_24h: 124494,
    market_cap_change_percentage_24h: 1.46118,
    circulating_supply: 73216955.7842337,
    total_supply: 501616955.784234,
    max_supply: null,
    ath: 1.99,
    ath_change_percentage: -94.07375,
    ath_date: "2024-12-01T10:49:32.626Z",
    atl: 0.099818,
    atl_change_percentage: 18.28884,
    atl_date: "2025-12-24T10:23:20.837Z",
    roi: null,
    last_updated: "2025-12-28T22:05:54.004Z",
    price_change_percentage_1h_in_currency: 0.000641013632658245,
    price_change_percentage_24h_in_currency: 1.46120698399725,
    price_change_percentage_7d_in_currency: -9.80963123779896,
  },
  {
    id: "apf-coin",
    symbol: "apfc",
    name: "APF coin",
    image:
      "https://coin-images.coingecko.com/coins/images/30990/large/photo_2023-10-28_09-48-25.jpg?1698518912",
    current_price: 0.080009,
    market_cap: 7405761,
    market_cap_rank: 1793,
    fully_diluted_valuation: 19994158,
    total_volume: 160693,
    high_24h: 0.081305,
    low_24h: 0.079346,
    price_change_24h: 0.00066301,
    price_change_percentage_24h: 0.83559,
    market_cap_change_24h: 59572,
    market_cap_change_percentage_24h: 0.81093,
    circulating_supply: 92599055.597,
    total_supply: 250000000,
    max_supply: 250000000,
    ath: 1.15,
    ath_change_percentage: -93.04692,
    ath_date: "2025-02-27T13:31:10.868Z",
    atl: 0.01792971,
    atl_change_percentage: 346.12164,
    atl_date: "2025-11-07T03:06:59.740Z",
    roi: null,
    last_updated: "2025-12-28T22:05:59.156Z",
    price_change_percentage_1h_in_currency: 0.236614412382705,
    price_change_percentage_24h_in_currency: 0.835588608514368,
    price_change_percentage_7d_in_currency: -0.434154404718319,
  },
  {
    id: "brickken",
    symbol: "bkn",
    name: "Brickken",
    image:
      "https://coin-images.coingecko.com/coins/images/18474/large/brickken-coin.png?1696517960",
    current_price: 0.1035,
    market_cap: 7378128,
    market_cap_rank: 1797,
    fully_diluted_valuation: 14774193,
    total_volume: 185118,
    high_24h: 0.105879,
    low_24h: 0.103058,
    price_change_24h: -0.000502536171269871,
    price_change_percentage_24h: -0.4832,
    market_cap_change_24h: -49014.2245964138,
    market_cap_change_percentage_24h: -0.65993,
    circulating_supply: 71413193.842985,
    total_supply: 143000000,
    max_supply: 143000000,
    ath: 1.39,
    ath_change_percentage: -92.55905,
    ath_date: "2024-03-28T14:50:50.563Z",
    atl: 0.069916,
    atl_change_percentage: 47.65604,
    atl_date: "2023-08-28T02:20:49.625Z",
    roi: null,
    last_updated: "2025-12-28T22:06:00.298Z",
    price_change_percentage_1h_in_currency: 0.132380888280904,
    price_change_percentage_24h_in_currency: -0.483196955234712,
    price_change_percentage_7d_in_currency: 1.52831272563982,
  },
  {
    id: "hifi-finance",
    symbol: "hifi",
    name: "Hifi Finance",
    image:
      "https://coin-images.coingecko.com/coins/images/28712/large/hft.png?1696527693",
    current_price: 0.0278873,
    market_cap: 4325758,
    market_cap_rank: 2196,
    fully_diluted_valuation: 4647041,
    total_volume: 595659,
    high_24h: 0.03207641,
    low_24h: 0.02720656,
    price_change_24h: -0.00211567114057122,
    price_change_percentage_24h: -7.05154,
    market_cap_change_24h: -341484.361238263,
    market_cap_change_percentage_24h: -7.31662,
    circulating_supply: 155429582.832107,
    total_supply: 166973661.004275,
    max_supply: null,
    ath: 2.63,
    ath_change_percentage: -98.93616,
    ath_date: "2023-09-16T16:00:16.674Z",
    atl: 0.02406476,
    atl_change_percentage: 16.0959,
    atl_date: "2025-12-23T07:29:00.348Z",
    roi: null,
    last_updated: "2025-12-28T22:06:02.785Z",
    price_change_percentage_1h_in_currency: 1.29680200370302,
    price_change_percentage_24h_in_currency: -7.0515382208113,
    price_change_percentage_7d_in_currency: 1.45116291781715,
  },
  {
    id: "estatex",
    symbol: "esx",
    name: "EstateX",
    image:
      "https://coin-images.coingecko.com/coins/images/36937/large/logo.jpeg?1712847900",
    current_price: 0.00309133,
    market_cap: 3816464,
    market_cap_rank: 2302,
    fully_diluted_valuation: 21642617,
    total_volume: 1902424,
    high_24h: 0.00311292,
    low_24h: 0.0030292,
    price_change_24h: 0.0000183,
    price_change_percentage_24h: 0.59534,
    market_cap_change_24h: 29084,
    market_cap_change_percentage_24h: 0.76791,
    circulating_supply: 1234381742.51915,
    total_supply: 7000000000,
    max_supply: 7000000000,
    ath: 0.02961462,
    ath_change_percentage: -89.53318,
    ath_date: "2025-06-30T07:06:03.766Z",
    atl: 0.00297794,
    atl_change_percentage: 4.08897,
    atl_date: "2025-12-24T16:32:15.412Z",
    roi: null,
    last_updated: "2025-12-28T22:06:01.911Z",
    price_change_percentage_1h_in_currency: 0.215341356780517,
    price_change_percentage_24h_in_currency: 0.595343283897832,
    price_change_percentage_7d_in_currency: -18.0001569566723,
  },
  {
    id: "propbase",
    symbol: "props",
    name: "Propbase",
    image:
      "https://coin-images.coingecko.com/coins/images/32932/large/PROP_BASE_%286%29.png?1699870054",
    current_price: 0.00757369,
    market_cap: 3457648,
    market_cap_rank: 2387,
    fully_diluted_valuation: 9086096,
    total_volume: 1602125,
    high_24h: 0.00762928,
    low_24h: 0.00750948,
    price_change_24h: 0.00004875,
    price_change_percentage_24h: 0.64791,
    market_cap_change_24h: 21226,
    market_cap_change_percentage_24h: 0.61766,
    circulating_supply: 456651279.627156,
    total_supply: 1200000000,
    max_supply: 1200000000,
    ath: 0.266874,
    ath_change_percentage: -97.16176,
    ath_date: "2024-04-05T01:21:56.673Z",
    atl: 0.00747633,
    atl_change_percentage: 1.31352,
    atl_date: "2025-12-27T10:51:07.184Z",
    roi: null,
    last_updated: "2025-12-28T22:05:53.796Z",
    price_change_percentage_1h_in_currency: 0.299771280841377,
    price_change_percentage_24h_in_currency: 0.647909730329361,
    price_change_percentage_7d_in_currency: -9.20080580278847,
  },
  {
    id: "defactor",
    symbol: "real",
    name: "Defactor",
    image:
      "https://coin-images.coingecko.com/coins/images/19201/large/Defactor_Emblem.png?1758135275",
    current_price: 0.01129724,
    market_cap: 3370937,
    market_cap_rank: 2403,
    fully_diluted_valuation: 3389171,
    total_volume: 65438,
    high_24h: 0.01177866,
    low_24h: 0.01121443,
    price_change_24h: 0.00002394,
    price_change_percentage_24h: 0.21238,
    market_cap_change_24h: 4162.71,
    market_cap_change_percentage_24h: 0.12364,
    circulating_supply: 298385961.615098,
    total_supply: 300000000,
    max_supply: 300000000,
    ath: 4,
    ath_change_percentage: -99.7176,
    ath_date: "2025-09-10T16:56:43.623Z",
    atl: 0.00018623,
    atl_change_percentage: 5966.17269,
    atl_date: "2025-10-01T03:55:34.881Z",
    roi: null,
    last_updated: "2025-12-28T22:06:01.277Z",
    price_change_percentage_1h_in_currency: -1.5244036326661,
    price_change_percentage_24h_in_currency: 0.212383720028614,
    price_change_percentage_7d_in_currency: -0.00784604400128581,
  },
  {
    id: "sabai-ecovers",
    symbol: "sabai",
    name: "Sabai Protocol",
    image:
      "https://coin-images.coingecko.com/coins/images/29573/large/sabaiprotocol_coin.png?1715563454",
    current_price: 0.00342193,
    market_cap: 1835287,
    market_cap_rank: 3038,
    fully_diluted_valuation: 9076065,
    total_volume: 944279,
    high_24h: 0.00348154,
    low_24h: 0.00340361,
    price_change_24h: -0.000043087378507205,
    price_change_percentage_24h: -1.2435,
    market_cap_change_24h: -24378.1059706043,
    market_cap_change_percentage_24h: -1.31089,
    circulating_supply: 535861018.453508,
    total_supply: 2650000000,
    max_supply: 2650000000,
    ath: 0.072849,
    ath_change_percentage: -95.29861,
    ath_date: "2024-07-20T17:22:41.692Z",
    atl: 0.00158392,
    atl_change_percentage: 116.23166,
    atl_date: "2025-04-18T13:19:47.208Z",
    roi: null,
    last_updated: "2025-12-28T22:05:38.389Z",
    price_change_percentage_1h_in_currency: 0.486249041363107,
    price_change_percentage_24h_in_currency: -1.2434952490282,
    price_change_percentage_7d_in_currency: -11.8920975690938,
  },
  {
    id: "landshare",
    symbol: "land",
    name: "Landshare",
    image:
      "https://coin-images.coingecko.com/coins/images/17507/large/Landshare.png?1696517046",
    current_price: 0.287781,
    market_cap: 1769022,
    market_cap_rank: 3076,
    fully_diluted_valuation: 1935471,
    total_volume: 172017,
    high_24h: 0.288186,
    low_24h: 0.28441,
    price_change_24h: 0.00328567,
    price_change_percentage_24h: 1.15491,
    market_cap_change_24h: 8124.61,
    market_cap_change_percentage_24h: 0.46139,
    circulating_supply: 6147108.4129537,
    total_supply: 6725495.95222892,
    max_supply: 10000000,
    ath: 12.19,
    ath_change_percentage: -97.63901,
    ath_date: "2021-11-11T13:36:04.206Z",
    atl: 0.27736,
    atl_change_percentage: 3.74445,
    atl_date: "2025-12-18T23:31:20.262Z",
    roi: null,
    last_updated: "2025-12-28T22:05:00.820Z",
    price_change_percentage_1h_in_currency: -0.0310336111355243,
    price_change_percentage_24h_in_currency: 1.15490987196232,
    price_change_percentage_7d_in_currency: -1.4901713767748,
  },
  {
    id: "blocksquare",
    symbol: "bst",
    name: "Blocksquare",
    image:
      "https://coin-images.coingecko.com/coins/images/23924/large/XpkkqPVR_400x400.jpg?1696523122",
    current_price: 0.02470725,
    market_cap: 1597286,
    market_cap_rank: 3189,
    fully_diluted_valuation: 1597286,
    total_volume: 103530,
    high_24h: 0.02477357,
    low_24h: 0.02465383,
    price_change_24h: 0.00005342,
    price_change_percentage_24h: 0.21666,
    market_cap_change_24h: 1068.22,
    market_cap_change_percentage_24h: 0.06692,
    circulating_supply: 64648466.9458284,
    total_supply: 64648466.9458284,
    max_supply: 100000000,
    ath: 0.932666,
    ath_change_percentage: -97.35098,
    ath_date: "2024-03-28T08:51:19.617Z",
    atl: 0.02278096,
    atl_change_percentage: 8.45253,
    atl_date: "2025-12-07T15:51:06.578Z",
    roi: null,
    last_updated: "2025-12-28T22:05:22.094Z",
    price_change_percentage_1h_in_currency: 0.0964161716916502,
    price_change_percentage_24h_in_currency: 0.216660905994306,
    price_change_percentage_7d_in_currency: -0.39291150204051,
  },
  {
    id: "leox",
    symbol: "leox",
    name: "LEOX",
    image:
      "https://coin-images.coingecko.com/coins/images/29980/large/LEOX-LOGO-BLACK-2.jpg?1696528905",
    current_price: 0.02387274,
    market_cap: 1209714,
    market_cap_rank: 3500,
    fully_diluted_valuation: 1209714,
    total_volume: 54464,
    high_24h: 0.02422288,
    low_24h: 0.02385114,
    price_change_24h: -0.00026065947351794,
    price_change_percentage_24h: -1.08008,
    market_cap_change_24h: -13208.5121917431,
    market_cap_change_percentage_24h: -1.08008,
    circulating_supply: 50673440,
    total_supply: 50673440,
    max_supply: 150000000,
    ath: 1.93,
    ath_change_percentage: -98.76488,
    ath_date: "2024-03-29T05:15:07.236Z",
    atl: 0.02159971,
    atl_change_percentage: 10.52345,
    atl_date: "2025-11-21T13:20:25.622Z",
    roi: null,
    last_updated: "2025-12-28T21:56:17.814Z",
    price_change_percentage_1h_in_currency: -0.0812523287444836,
    price_change_percentage_24h_in_currency: -1.08007756762121,
    price_change_percentage_7d_in_currency: 0.629789083756161,
  },
  {
    id: "xend-finance",
    symbol: "rwa",
    name: "Xend Finance",
    image:
      "https://coin-images.coingecko.com/coins/images/14496/large/WeChat_Image_20210325163206.png?1696514181",
    current_price: 0.00382826,
    market_cap: 764336,
    market_cap_rank: 4046,
    fully_diluted_valuation: 764336,
    total_volume: 14636.13,
    high_24h: 0.00382852,
    low_24h: 0.00381996,
    price_change_24h: 0.00000694,
    price_change_percentage_24h: 0.18152,
    market_cap_change_24h: -1101.81232335139,
    market_cap_change_percentage_24h: -0.14395,
    circulating_supply: 200000000,
    total_supply: 200000000,
    max_supply: null,
    ath: 3,
    ath_change_percentage: -99.87263,
    ath_date: "2021-03-28T07:16:54.324Z",
    atl: 0.00055582,
    atl_change_percentage: 587.5752,
    atl_date: "2024-02-07T19:55:49.145Z",
    roi: null,
    last_updated: "2025-12-28T22:05:22.013Z",
    price_change_percentage_1h_in_currency: 0.21097011226034,
    price_change_percentage_24h_in_currency: 0.181524288759089,
    price_change_percentage_7d_in_currency: -0.864092701085803,
  },
  {
    id: "moon-app",
    symbol: "app",
    name: "RWAX",
    image:
      "https://coin-images.coingecko.com/coins/images/34492/large/rwax-token.png?1730443514",
    current_price: 0.00036212,
    market_cap: 718537,
    market_cap_rank: 4122,
    fully_diluted_valuation: 1085433,
    total_volume: 204729,
    high_24h: 0.00044713,
    low_24h: 0.00034557,
    price_change_24h: -0.000083785823604079,
    price_change_percentage_24h: -18.78993,
    market_cap_change_24h: -174180.0339712,
    market_cap_change_percentage_24h: -19.51123,
    circulating_supply: 1985944981.93395,
    total_supply: 3000000000,
    max_supply: 3000000000,
    ath: 0.05037,
    ath_change_percentage: -99.28108,
    ath_date: "2024-01-17T16:15:02.574Z",
    atl: 0.00016759,
    atl_change_percentage: 116.07695,
    atl_date: "2025-12-22T19:57:28.781Z",
    roi: null,
    last_updated: "2025-12-28T22:04:40.419Z",
    price_change_percentage_1h_in_currency: -4.98219659912695,
    price_change_percentage_24h_in_currency: -18.7899326570301,
    price_change_percentage_7d_in_currency: 64.8206264425813,
  },
  {
    id: "home3",
    symbol: "hts",
    name: "Home3",
    image:
      "https://coin-images.coingecko.com/coins/images/38599/large/1000085865.jpg?1718094997",
    current_price: 0.0075701,
    market_cap: 676319,
    market_cap_rank: 4199,
    fully_diluted_valuation: 730440,
    total_volume: 2783.1,
    high_24h: 0.00757075,
    low_24h: 0.00701443,
    price_change_24h: 0.00054952,
    price_change_percentage_24h: 7.82734,
    market_cap_change_24h: 49419,
    market_cap_change_percentage_24h: 7.88304,
    circulating_supply: 89350000,
    total_supply: 96500000,
    max_supply: 100000000,
    ath: 0.097616,
    ath_change_percentage: -92.24677,
    ath_date: "2024-12-08T23:54:41.360Z",
    atl: 0.0045298,
    atl_change_percentage: 67.08055,
    atl_date: "2025-09-02T07:59:29.112Z",
    roi: null,
    last_updated: "2025-12-28T22:05:46.127Z",
    price_change_percentage_1h_in_currency: 0.0349095143679695,
    price_change_percentage_24h_in_currency: 7.82733932528481,
    price_change_percentage_7d_in_currency: 0.225882949457845,
  },
  {
    id: "gcoin",
    symbol: "gc",
    name: "GCoin",
    image:
      "https://coin-images.coingecko.com/coins/images/52486/large/image_1_1.webp?1733429194",
    current_price: 0.0060677,
    market_cap: 606770,
    market_cap_rank: 4333,
    fully_diluted_valuation: 606770,
    total_volume: 477.62,
    high_24h: 0.00654369,
    low_24h: 0.00576675,
    price_change_24h: 0.00025616,
    price_change_percentage_24h: 4.40776,
    market_cap_change_24h: 25616,
    market_cap_change_percentage_24h: 4.40776,
    circulating_supply: 100000000,
    total_supply: 100000000,
    max_supply: 100000000,
    ath: 0.064704,
    ath_change_percentage: -90.61246,
    ath_date: "2024-12-06T19:53:46.891Z",
    atl: 0.00299223,
    atl_change_percentage: 102.99677,
    atl_date: "2025-03-31T10:21:38.185Z",
    roi: null,
    last_updated: "2025-12-28T22:00:53.344Z",
    price_change_percentage_1h_in_currency: -0.0933657582318327,
    price_change_percentage_24h_in_currency: 4.40776397953947,
    price_change_percentage_7d_in_currency: 0.355201068127163,
  },
  {
    id: "rkey",
    symbol: "rkey",
    name: "Rkey",
    image:
      "https://coin-images.coingecko.com/coins/images/37457/large/RKEY_logo.jpg?1718596389",
    current_price: 0.00112219,
    market_cap: 485814,
    market_cap_rank: 4612,
    fully_diluted_valuation: 1117513,
    total_volume: 68288,
    high_24h: 0.00115115,
    low_24h: 0.00110317,
    price_change_24h: -0.000013036957404384,
    price_change_percentage_24h: -1.1484,
    market_cap_change_24h: -8231.8740283075,
    market_cap_change_percentage_24h: -1.66622,
    circulating_supply: 432916667.608713,
    total_supply: 995833334,
    max_supply: 1000000000,
    ath: 0.00959271,
    ath_change_percentage: -88.31207,
    ath_date: "2025-05-12T07:09:05.748Z",
    atl: 0.00049158,
    atl_change_percentage: 128.07943,
    atl_date: "2024-06-27T07:19:43.207Z",
    roi: null,
    last_updated: "2025-12-28T21:55:40.028Z",
    price_change_percentage_1h_in_currency: 0.720487379574608,
    price_change_percentage_24h_in_currency: -1.14840215661703,
    price_change_percentage_7d_in_currency: 36.5594736807174,
  },
  {
    id: "landx-governance-token",
    symbol: "lndx",
    name: "LandX Governance Token",
    image:
      "https://coin-images.coingecko.com/coins/images/33565/large/LNDX-200.png?1702445947",
    current_price: 0.02540634,
    market_cap: 334772,
    market_cap_rank: 5132,
    fully_diluted_valuation: 1778773,
    total_volume: 72773,
    high_24h: 0.02572197,
    low_24h: 0.02533224,
    price_change_24h: -0.00014443688183766,
    price_change_percentage_24h: -0.56529,
    market_cap_change_24h: -1904.01076348859,
    market_cap_change_percentage_24h: -0.56553,
    circulating_supply: 13176747.817754,
    total_supply: 70013149.650578,
    max_supply: 80000000,
    ath: 3.58,
    ath_change_percentage: -99.29097,
    ath_date: "2024-03-28T04:34:45.118Z",
    atl: 0.02357788,
    atl_change_percentage: 7.75498,
    atl_date: "2025-12-18T20:00:08.949Z",
    roi: null,
    last_updated: "2025-12-28T22:05:20.361Z",
    price_change_percentage_1h_in_currency: 0.0850375866659433,
    price_change_percentage_24h_in_currency: -0.565293567794221,
    price_change_percentage_7d_in_currency: 2.13393152866362,
  },
  {
    id: "lympid",
    symbol: "lyp",
    name: "Lympid",
    image:
      "https://coin-images.coingecko.com/coins/images/53786/large/LYP_200X200.png?1737358652",
    current_price: 0.00751162,
    market_cap: 287033,
    market_cap_rank: 5355,
    fully_diluted_valuation: 751031,
    total_volume: 165710,
    high_24h: 0.00762365,
    low_24h: 0.00751157,
    price_change_24h: -0.000027988843496094,
    price_change_percentage_24h: -0.37122,
    market_cap_change_24h: 8640.35,
    market_cap_change_percentage_24h: 3.10366,
    circulating_supply: 38212123.4564115,
    total_supply: 99983205.6864115,
    max_supply: 100000000,
    ath: 0.281181,
    ath_change_percentage: -97.31271,
    ath_date: "2025-01-27T16:45:31.234Z",
    atl: 0.00752135,
    atl_change_percentage: 0.46255,
    atl_date: "2025-12-27T16:54:04.203Z",
    roi: null,
    last_updated: "2025-12-28T22:05:29.320Z",
    price_change_percentage_1h_in_currency: -0.702928430262103,
    price_change_percentage_24h_in_currency: -0.371224005586286,
    price_change_percentage_7d_in_currency: -3.77583699961721,
  },
  {
    id: "rem-token",
    symbol: "rem",
    name: "REM Token",
    image:
      "https://coin-images.coingecko.com/coins/images/53763/large/logo_icons-12.png?1737191145",
    current_price: 0.00211547,
    market_cap: 171292,
    market_cap_rank: 6123,
    fully_diluted_valuation: 2115471,
    total_volume: 45014,
    high_24h: 0.00217156,
    low_24h: 0.00211042,
    price_change_24h: -0.000023070555122971,
    price_change_percentage_24h: -1.0788,
    market_cap_change_24h: -1865.32913195496,
    market_cap_change_percentage_24h: -1.07724,
    circulating_supply: 80971310.690935,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 0.586109,
    ath_change_percentage: -99.63923,
    ath_date: "2025-04-15T15:27:06.493Z",
    atl: 0.00053006,
    atl_change_percentage: 298.91387,
    atl_date: "2025-04-09T05:46:53.823Z",
    roi: null,
    last_updated: "2025-12-28T21:57:58.188Z",
    price_change_percentage_1h_in_currency: 0.239151395010977,
    price_change_percentage_24h_in_currency: -1.07879855358015,
    price_change_percentage_7d_in_currency: 3.6812882170176,
  },
  {
    id: "ubxs-token",
    symbol: "ubxs",
    name: "UBXS",
    image:
      "https://coin-images.coingecko.com/coins/images/22558/large/logo_200x200.png?1696521877",
    current_price: 0.00194948,
    market_cap: 105342,
    market_cap_rank: 6884,
    fully_diluted_valuation: 191049,
    total_volume: 1691.95,
    high_24h: 0.00200207,
    low_24h: 0.00194246,
    price_change_24h: 0.00000702,
    price_change_percentage_24h: 0.36115,
    market_cap_change_24h: 342.96,
    market_cap_change_percentage_24h: 0.32663,
    circulating_supply: 54036257,
    total_supply: 98000000,
    max_supply: 100000000,
    ath: 0.618556,
    ath_change_percentage: -99.68483,
    ath_date: "2024-03-28T11:12:37.854Z",
    atl: 0.0018561,
    atl_change_percentage: 5.03078,
    atl_date: "2025-12-25T10:57:40.686Z",
    roi: null,
    last_updated: "2025-12-28T22:01:50.707Z",
    price_change_percentage_1h_in_currency: 0.170639333181296,
    price_change_percentage_24h_in_currency: 0.361153950935971,
    price_change_percentage_7d_in_currency: -9.86371387892806,
  },
  {
    id: "rentberry",
    symbol: "berry",
    name: "Rentberry",
    image:
      "https://coin-images.coingecko.com/coins/images/1787/large/rentberry.png?1696502792",
    current_price: 0.00029992,
    market_cap: 90418,
    market_cap_rank: 7138,
    fully_diluted_valuation: 90418,
    total_volume: 3.34,
    high_24h: 0.00030787,
    low_24h: 0.00029928,
    price_change_24h: -0.00000629497062333,
    price_change_percentage_24h: -2.05573,
    market_cap_change_24h: -1897.76384869148,
    market_cap_change_percentage_24h: -2.05573,
    circulating_supply: 301473027,
    total_supply: 301473027,
    max_supply: null,
    ath: 0.115481,
    ath_change_percentage: -99.74029,
    ath_date: "2018-04-28T11:35:00.848Z",
    atl: 0.00004519,
    atl_change_percentage: 563.69702,
    atl_date: "2024-07-03T21:05:21.977Z",
    roi: {
      times: -0.999744581391139,
      currency: "eth",
      percentage: -99.9744581391139,
    },
    last_updated: "2025-12-28T21:58:31.083Z",
    price_change_percentage_1h_in_currency: 0.181336375052344,
    price_change_percentage_24h_in_currency: -2.05572986847371,
    price_change_percentage_7d_in_currency: 32.9072279515273,
  },
  {
    id: "rentible",
    symbol: "rnb",
    name: "Rentible",
    image:
      "https://coin-images.coingecko.com/coins/images/15176/large/rnb_200x200.png?1703145247",
    current_price: 0.0080987,
    market_cap: 80987,
    market_cap_rank: 7347,
    fully_diluted_valuation: 80987,
    total_volume: 3.97,
    high_24h: 0.00812665,
    low_24h: 0.00806569,
    price_change_24h: 0.00002746,
    price_change_percentage_24h: 0.34021,
    market_cap_change_24h: 274.59,
    market_cap_change_percentage_24h: 0.34021,
    circulating_supply: 10000000,
    total_supply: 10000000,
    max_supply: 10000000,
    ath: 5.38,
    ath_change_percentage: -99.84936,
    ath_date: "2021-05-04T20:59:22.265Z",
    atl: 0.00005228,
    atl_change_percentage: 15390.77386,
    atl_date: "2023-12-18T12:40:45.879Z",
    roi: null,
    last_updated: "2025-12-28T04:00:08.195Z",
    price_change_percentage_1h_in_currency: null,
    price_change_percentage_24h_in_currency: 0.340208214720764,
    price_change_percentage_7d_in_currency: -1.26080195238871,
  },
  {
    id: "meta-bitcoin-super",
    symbol: "mbtcs",
    name: "Meta Bitcoin Super",
    image:
      "https://coin-images.coingecko.com/coins/images/50962/large/MBTCs-Logo2_200x200.png?1729592580",
    current_price: 0.242215,
    market_cap: 40520,
    market_cap_rank: 8526,
    fully_diluted_valuation: 5086513,
    total_volume: 8931.81,
    high_24h: 0.243629,
    low_24h: 0.241706,
    price_change_24h: 0.00047359,
    price_change_percentage_24h: 0.19591,
    market_cap_change_24h: 81.93,
    market_cap_change_percentage_24h: 0.20261,
    circulating_supply: 167289.801689067,
    total_supply: 21000000,
    max_supply: 21000000,
    ath: 9.97,
    ath_change_percentage: -97.57226,
    ath_date: "2024-11-08T08:24:38.197Z",
    atl: 0.241697,
    atl_change_percentage: 0.15241,
    atl_date: "2025-12-27T03:39:28.387Z",
    roi: null,
    last_updated: "2025-12-28T21:56:30.332Z",
    price_change_percentage_1h_in_currency: 0.0230293497979963,
    price_change_percentage_24h_in_currency: 0.195906361043619,
    price_change_percentage_7d_in_currency: -0.657610741810835,
  },
  {
    id: "real-estate-crypto-crowfunding",
    symbol: "recc",
    name: "Real Estate Crypto Crowfunding",
    image:
      "https://coin-images.coingecko.com/coins/images/67492/large/png_recc.png?1756412782",
    current_price: 0.0000178,
    market_cap: 15525.35,
    market_cap_rank: 10262,
    fully_diluted_valuation: 17305.74,
    total_volume: 735.44,
    high_24h: 0.00001844,
    low_24h: 0.0000178,
    price_change_24h: -6.15175832426e-7,
    price_change_percentage_24h: -3.33988,
    market_cap_change_24h: -508.970487537539,
    market_cap_change_percentage_24h: -3.17426,
    circulating_supply: 872018844.609251,
    total_supply: 972018844.609317,
    max_supply: 1000000000,
    ath: 0.00367015,
    ath_change_percentage: -99.51495,
    ath_date: "2025-09-03T04:29:30.546Z",
    atl: 0.0000178,
    atl_change_percentage: 0,
    atl_date: "2025-12-28T21:42:10.165Z",
    roi: null,
    last_updated: "2025-12-28T21:59:54.838Z",
    price_change_percentage_1h_in_currency: -2.24787572760106,
    price_change_percentage_24h_in_currency: -3.33988152204982,
    price_change_percentage_7d_in_currency: -96.7666374122671,
  },
];
export const languages = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
  { code: "de", label: "Deutsch" },
  { code: "pt", label: "Português" },
  { code: "it", label: "Italiano" },
  { code: "nl", label: "Nederlands" },
  { code: "ru", label: "Русский" },
  { code: "ar", label: "العربية" },
  { code: "hi", label: "हिन्दी" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
];
